import { memo } from 'react';

import type {
  LoaderSize,
  LoaderVariant,
} from '@components/common/Loader/types';

import { Box, CircularProgress, Stack } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';

import { sxProperties } from '@components/common/Loader/styles/sxProperties';

interface ILoader {
  size?: LoaderSize;
  variant?: LoaderVariant;
}

const LoaderComponent = ({ size = 'small', variant = 'linear' }: ILoader) => {
  const isIframe = window.self !== window.top;

  const { linearLoaderWrapperStyles, circularLoaderWrapperStyles } =
    sxProperties({
      isIframe,
    });

  if (variant === 'linear') {
    return (
      <Box sx={linearLoaderWrapperStyles}>
        <LinearProgress color="primary" />
      </Box>
    );
  }

  return (
    <Stack sx={circularLoaderWrapperStyles}>
      <CircularProgress color="primary" size={size} />
    </Stack>
  );
};

export const Loader = memo(LoaderComponent);
